const THICKNESS = [
  {
    name: "1/8 inch",
    code: "FCO_18",
    value: "1/8 inch",
    brief: "Standard thin acrylic thickness for lightweight signs.",
  },
  {
    name: "1/4 inch",
    code: "FCO_14",
    value: "1/4 inch",
    brief: "Standard thin acrylic thickness for lightweight signs.",
  },
  {
    name: "3/8 inch",
    code: "FCO_38",
    value: "3/8 inch",
    brief: "Standard thin acrylic thickness for lightweight signs.",
  },
  {
    name: "1/2 inch",
    code: "FCO_12",
    value: "1/2 inch",
    brief: "Standard thin acrylic thickness for lightweight signs.",
  },
];

const BL3THICKNESS = [
  {
    name: "1/4 inch",
    code: "FCO_14",
    value: "1/4 inch",
    brief: "Standard thin acrylic thickness for lightweight signs.",
  },
  {
    name: "3/8 inch",
    code: "FCO_38",
    value: "3/8 inch",
    brief: "Standard thin acrylic thickness for lightweight signs.",
  },
  {
    name: "1/2 inch",
    code: "FCO_12",
    value: "1/2 inch",
    brief: "Standard thin acrylic thickness for lightweight signs.",
  },
  {
    name: "3/4 inch",
    code: "FCO_34",
    value: "3/4 inch",
    brief: "Standard thin acrylic thickness for lightweight signs.",
  },
  {
    name: "1 inch",
    code: "FCO_10",
    value: "1 inch",
    brief: "Standard thin acrylic thickness for lightweight signs.",
  },
];

const BL32THICKNESS = [
  {
    name: "1/4 inch",
    code: "FCO_14",
    value: "1/4 inch",
    brief: "Standard.",
  },
  {
    name: "3/8 inch",
    code: "FCO_38",
    value: "3/8 inch",
    brief: "Standard.",
  },
  {
    name: "1/2 inch",
    code: "FCO_12",
    value: "1/2 inch",
    brief: "Standard.",
  },
];

const BL33THICKNESS = [
  {
    name: "1/4 inch",
    code: "FCO_14",
    value: "1/4 inch",
    brief: "Standard.",
  },
  {
    name: "3/8 inch",
    code: "FCO_38",
    value: "3/8 inch",
    brief: "Standard.",
  },
  {
    name: "1/2 inch",
    code: "FCO_12",
    value: "1/2 inch",
    brief: "Standard.",
  },
];

const PFL10THICKNESS = [
  {
    name: "1/2 inch",
    code: "one_half_inch",
    value: "1/2 inch",
    brief: "Standard.",
  },
  {
    name: "3/4 inch",
    code: "three_quarter_inch",
    value: "3/4 inch",
    brief: "Standard.",
  },
  {
    name: "1 inch",
    code: "one_inch",
    value: "1 inch",
    brief: "Standard.",
  },
  {
    name: "1-1/2 inch",
    code: "one_and_half_inch",
    value: "1-1/2 inch",
    brief: "Standard.",
  },
  {
    name: "2 inch",
    code: "two_inch",
    value: "1-1/2 inch",
    brief: "Standard.",
  },
];

const BL70THICKNESS = [
  {
    name: "1/4 inch",
    code: "FCO_14",
    value: "1/4 inch",
    brief: "Standard.",
  },
  {
    name: "3/8 inch",
    code: "FCO_38",
    value: "3/8 inch",
    brief: "Standard.",
  },
  {
    name: "1/2 inch",
    code: "FCO_12",
    value: "1/2 inch",
    brief: "Standard.",
  },
  {
    name: "3/4 inch",
    code: "FCO_34",
    value: "3/4 inch",
    brief: "Standard.",
  },
  {
    name: "1 inch",
    code: "FCO_10",
    value: "1 inch",
    brief: "Standard.",
  },
  {
    name: "1-1/2 inch",
    code: "FCO_112",
    value: "1-1/2 inch",
    brief: "Standard.",
  },
];


export const THICKNESSES_MAP = {
  ML1000: null,
  BL1000: null,
  BL2000: null,
  BL2200: null,
  BL31000: BL3THICKNESS,
  BL32000: BL32THICKNESS,
  BL33000: BL33THICKNESS,
  BL40100: THICKNESS,
  BL40200: THICKNESS,
  PFL100: PFL10THICKNESS,
  BL70100: BL70THICKNESS,
};

export const getThicknessByProductCode = (productCode) => {
  if (!productCode) {
    console.warn("No product code provided");
    return [];
  }
  const thicknesses = THICKNESSES_MAP[productCode];
  if (!thicknesses) {
    console.warn(`No thicknesses defined for product code: ${productCode}`);
    return [];
  }
  return thicknesses;
};
